<template>
  <custom-dialog class="approval-detail-dialog" width="1450px" :title="title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <div class="approval-content">
        <div class="side">
          <div class="bar-container">
            <div class="process-bar">
              <div class="process-bar-item" :class="getBarItemClass(item)" v-for="(item, index) in barData" :key="index">
                <div class="header">
                  <div class="circle">{{ index + 1 }}</div>
                  <div class="title">{{ item.title }}</div>
                </div>
                <div class="content">
                  <div class="sub-title" v-for="(obj, j) in item.child" :key="j">
                    <span>{{ obj.key }}</span>
                    <span>{{ obj.val }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="msg-content">
          <div class="inner-content">
            <!-- 变更账单类型 -->
            <invoice-change-state v-if="showVisible === 'change_bill_trade_state'" ref="change_bill_trade_state" :model="modelData"></invoice-change-state>
            <!-- 延期付款 -->
            <invoice-delay-receive v-if="showVisible === 'deferred'" ref="deferred" :model="modelData"></invoice-delay-receive>
            <!-- 撤销收款 -->
            <invoice-rovoke-receive v-if="showVisible === 'withdrawal_payment'" ref="withdrawal_payment" :model="modelData"></invoice-rovoke-receive>
            <!-- 库存管理-申请免收 -->
            <apply-free v-if="showVisible === 'free_stock_fee'" ref="free_stock_fee" :model="modelData"></apply-free>
            <!-- 逾期费-申请免收 -->
            <apply-free v-if="showVisible === 'free_overdue_fee'" ref="free_overdue_fee" :model="modelData"></apply-free>
            <!-- 免收违约金 -->
            <apply-free v-if="showVisible === 'free_break_fee'" ref="free_break_fee" :model="modelData"></apply-free>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import invoiceChangeState from '@/components/approvalCenter/invoice_change_state.vue';
import invoiceRovokeReceive from '@/components/approvalCenter/invoice_revoke_receive.vue';
import invoiceDelayReceive from '@/components/approvalCenter/invoice_delay_receive.vue';
import applyFree from '@/components/approvalCenter/apply_free';

export default {
  mixins: [dialogMixins],
  props: {
    workflowType: String,
    bizId: [String, Number],
    row: Object,
  },

  components: {
    invoiceChangeState,
    invoiceRovokeReceive,
    invoiceDelayReceive,
    applyFree,
  },

  data() {
    return {
      applicationBo: {},
      approvalNodeList: [],
      titleDic: {},
      modelData: {},
      showVisible: '',
    };
  },
  computed: {
    title() {
      return this.titleDic[this.workflowType] || '';
    },
    barData() {
      const ret = [];

      const applyItem = {
        title: this.$t('components_approvalDetailDialog.shen_qing'),
        child: [
          {
            key: this.$t('components_approvalDetailDialog.shen_qing_ren'),
            val: this.applicationBo.applyUser,
          },
        ],
        flowNodeNo: 0,
      };
      if (this.applicationBo.applyTime) {
        applyItem.child.push({
          key: this.$t('components_approvalDetailDialog.shen_qing_shi_jian'),
          val: this.momentAmPm(this.$momentLocal(this.applicationBo.applyTime)),
        });
      }
      if (this.applicationBo.applyReason) {
        applyItem.child.push({
          key: this.$t('components_approvalDetailDialog.sqrssgs'),
          val: this.applicationBo.applyOrgName,
        });
      }
      if (this.applicationBo.approvalState) {
        applyItem.child.push({
          key: this.$t('components_approvalDetailDialog.shen_qing_zhuang_tai'),
          val: this.getDicValue('crm_contract_approval_state', this.applicationBo.approvalState),
        });
      }
      if (this.applicationBo.applyReason) {
        applyItem.child.push({
          key: this.$t('components_approvalDetailDialog.shen_qing_yuan_yin'),
          val: this.applicationBo.applyReason,
        });
      }

      ret.push(applyItem);

      // 过滤抄送节点
      const list = this.approvalNodeList.filter((item) => item.approverPerm !== 2);
      const insertList = list.map((item) => {
        const child = [
          {
            key: this.$t('components_approvalDetailDialog.shen_pi_ren'),
            val: item.approvalLog ? item.approvalLog.approverName : item.approvalRoleName || item.approverNames,
          },
        ];

        if (item.approvalLog) {
          if (item.approvalLog.approvalTime) {
            child.push({
              key: this.$t('components_approvalDetailDialog.shen_pi_shi_jian'),
              val: this.momentAmPm(this.$momentLocal(item.approvalLog.approvalTime)),
            });
          }
          if (item.approvalLog.approvalState) {
            child.push({
              key: this.$t('components_approvalDetailDialog.shen_pi_zhuang_tai'),
              val: this.getDicValue('crm_contract_approval_state', item.approvalLog.approvalState),
            });
          }
          if (item.approvalLog.approvalOpinion) {
            child.push({
              key: this.$t('components_approvalDetailDialog.shen_pi_yi_jian'),
              val: item.approvalLog.approvalOpinion,
            });
          }
        }

        return {
          title: item.flowNodeName,
          child,
          flowNodeNo: item.flowNodeNo,
        };
      });
      ret.push(...insertList);

      return ret;
    },
  },
  mounted() {
    this.modelData = {
      changeType: this.workflowType,
      changeId: this.bizId,
      type: 'watch',
      row: Array.isArray(this.row) ? this.row : [this.row],
    };
    this.showVisible = this.workflowType;
    this.getDictionary('approval_type', (data) => {
      this.titleDic = this.$listTransObject(data.approval_type, 'value', 'name');
      this.getPageInfo();
    });
  },
  methods: {
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
    },

    getPageInfo() {
      this.$getJSON(`${apis.apsApproveApprovalInfo}/${this.workflowType}/${this.bizId}`).then((res) => {
        const { applicationBo, approvalNodeList } = res.data;
        this.applicationBo = applicationBo;
        this.approvalNodeList = approvalNodeList;
      });
    },

    getBarItemClass(item) {
      if (item.flowNodeNo > this.applicationBo.currentNodeNo) {
        return 'next';
      }
      if (item.flowNodeNo === this.applicationBo.currentNodeNo) {
        return 'cur';
      }
      return 'pre';
    },
  },
};
</script>

<style lang="scss">
$borderColor: #e9ebec;

.approval-detail-dialog {
  .approval-content {
    flex: 1;
    background: #fff;
    display: flex;
    overflow: hidden;
    > .side {
      width: 314px;
      border-right: 1px solid $borderColor;
      .bar-container {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 24px;

        .process-bar {
          margin-left: 1px;
          margin-top: 4px;

          font-size: 12px;
          .process-bar-item {
            &:last-child {
              .content {
                &::before {
                  display: none;
                }
              }
            }
            &.next {
              .header .circle {
                background: #98a6ad;
              }
              .content {
                &::before {
                  background: #dee2e6;
                }
              }
            }
            &.cur {
              .content {
                &::before {
                  background: #dee2e6;
                }
              }
            }
            .header {
              overflow: hidden;
              .circle {
                float: left;
                width: 17px;
                height: 17px;
                border-radius: 100%;
                background: #4a90e2;
                line-height: 18px;
                text-align: center;
                color: #fff;
              }
              .title {
                float: left;
                color: #495057;
                line-height: 18px;
                margin-left: 12px;
                font-weight: bold;
              }
            }
            .content {
              padding-left: 29px;
              min-height: 58px;
              overflow: hidden;
              position: relative;
              padding-bottom: 32px;

              &::before {
                content: ' ';
                position: absolute;
                width: 1px;
                background: #0d9ae0;
                left: 8px;
                top: 5px;
                bottom: 5px;
              }

              .sub-title {
                color: #6c757d;
                margin-top: 6px;
                line-height: 20px;
              }
            }
          }
        }
      }
    }
    > .msg-content {
      flex: 1;
      overflow-y: auto;
      > .inner-content {
        padding: 24px;
      }
    }
  }
}
</style>
